<template>
  <!-- 案件详情-资料映像信息 -->
  <div class="imageInfo-block">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <!-- 照片资料 -->
      <el-tab-pane
        v-if="checkPermission('资料映像栏-照片资料:查看', permList)"
        label="照片资料"
        name="caseFileViewer"
      >
        <ul id="caseFileViewer" class="uploader_files case_detail_uploader_files">
          <li
            v-for="(item, index) in caseFilePicList"
            :key="'caseFilePic' + index"
            class="uploader_file_block"
          >

            <v-imageItems :item="item" :index="index" canvas-type="case_canvas_" img-type="Annex" />
            <span class="uploader_file_name">{{ item.name }}</span>
          </li>
        </ul>
      </el-tab-pane>

      <!-- 扫描件资料 -->
      <el-tab-pane
        v-if="checkPermission('纸质材料扫描件:查看', permList)"
        label="扫描件资料"
        name="scanFileViewer"
      >
        <div class="uploader_content">
          <ul id="scanFileViewer" class="uploader_files case_detail_uploader_files">
            <el-checkbox-group
              v-for="(item, index) in scanFilePicList"
              :key="'scanFilePic' + index"
              v-model="tagTechnicalSelection"
              class="uploader_file_block"
              :disabled="!(checkPermission('扫描件材料-转移到公示材料', permList) || checkPermission('扫描件材料-转移到归档材料', permList))"
            >
              <li>
                <!-- 资料上传进度的模块 -->
                <div v-if="item.percentage < 100 && item.percentage >= 0">
                  <!-- 删除按钮 -->
                  <span
                    v-if="!isCaseArchive"
                    class="uploader_file_del_icon"
                    @click.stop="delLi('scanFilePicList', index)"
                  >
                    <i class="el-icon-close" style="color: white" />
                  </span>
                  <div class="uploader_file">
                    <el-progress
                      type="circle"
                      :color="colors"
                      :percentage="item.percentage"
                    />
                  </div>
                </div>

                <div v-else>
                  <!-- 删除按钮 -->
                  <span
                    v-if="(checkPermission('扫描件资料-图片:删除', permList) || item.isDelete) && !isCaseArchive"
                    class="uploader_file_del_icon"
                    @click.stop="delLi('scanFilePicList', index)"
                  >
                    <i class="el-icon-close" style="color: white" />
                  </span>

                  <v-imageItems :item="item" :index="index" canvas-type="scan_canvas_" img-type="PaperScan" />
                </div>
                <div class="uploader_file_name">
                  <el-checkbox :key="item.url" :label="item" class="checkbox-block">
                    {{ convertFilesName("scanFilePicList", item.url, item.name) }}
                  </el-checkbox>
                </div>
              </li>
            </el-checkbox-group>
          </ul>
          <!-- 上传文件按钮 -->
          <div
            v-if="checkPermission('纸质材料扫描件:编辑', permList) && !isCaseArchive"
            class="uploader_file_uploader"
          >
            <div class="uploader_input_wrp">
              <i class="el-icon-plus" style="font-size: 28px" />
              <input
                type="file"
                multiple="multiple"
                class="uploader_input"
                :accept="uploadFileType"
                @change="chooseImage('scanFilePicList', $event)"
              >
            </div>
          </div>
        </div>

        <div class="uploader_button flex">
          <el-button
            v-if="checkPermission('纸质材料扫描件:编辑', permList)"
            type="primary"
            icon="el-icon-upload"
            :loading="scanFileloading"
            :disabled="uploadingNum > 0 || isCaseArchive"
            @click.stop="savePic('scanFilePicList')"
          >
            保存资料
          </el-button>

          <el-button
            v-if="checkPermission('扫描件材料-转移到公示材料', permList)"
            type="primary"
            icon="el-icon-document-copy"
            :loading="transferPicloading"
            :disabled="isCaseArchive"
            @click.stop="transferPic('scanFilePicList', 'PublicEstimate')"
          >
            转移到公示材料
          </el-button>

          <el-button
            v-if="checkPermission('扫描件材料-转移到归档材料', permList)"
            type="primary"
            icon="el-icon-document-copy"
            :loading="transferPicloading"
            :disabled="isCaseArchive"
            @click.stop="transferPic('scanFilePicList', 'CloseFile')"
          >
            转移到归档资料
          </el-button>
        </div>
      </el-tab-pane>

      <!-- 公估调查资料 -->
      <el-tab-pane
        v-if="checkPermission('公估调查结果:查看', permList)"
        label="公估调查资料"
        name="valuationFileViewer"
      >
        <el-tabs v-model="assessmentActiveName" type="border-card" @tab-click="onChangeAssessmentTag">
          <el-tab-pane
            v-for="(assessmentItem, assessmentIndex) in assessmentSurveyList.filter(item => checkPermission(item.checkPermissions, permList))"
            :key="'assessment_' + assessmentIndex"
            :label="assessmentItem.title"
            :name="assessmentItem.name"
          >
            <div class="uploader_content">
              <ul id="valuationFileViewer" class="uploader_files case_detail_uploader_files">
                <el-checkbox-group
                  v-for="(cItem, cIndex) in assessmentItem.children"
                  :key="assessmentItem.key + '_' + cIndex"
                  v-model="tagTechnicalSelection"
                  class="uploader_file_block"
                  :disabled="!(checkPermission(assessmentItem.toPMaterialPermissions, permList) || checkPermission(assessmentItem.toAMaterialPermissions, permList))"
                >
                  <li>
                    <!-- 资料上传进度的模块 -->
                    <div v-if="cItem.percentage < 100 && cItem.percentage >= 0">
                      <!-- 删除按钮 -->
                      <span
                        v-if="!isCaseArchive"
                        class="uploader_file_del_icon"
                        @click.stop="delLi(assessmentItem.key, cIndex)"
                      >
                        <i class="el-icon-close" style="color: white" />
                      </span>
                      <div class="uploader_file">
                        <el-progress
                          type="circle"
                          :color="colors"
                          :percentage="cItem.percentage"
                        />
                      </div>
                    </div>
                    <div v-else>
                      <!-- 删除按钮 -->
                      <span
                        v-if="(checkPermission(assessmentItem.deletePermissions, permList) || cItem.isDelete) && !isCaseArchive"
                        class="uploader_file_del_icon"
                        @click.stop="delLi(assessmentItem.key, cIndex)"
                      >
                        <i class="el-icon-close" style="color: white" />
                      </span>

                      <v-imageItems :item="cItem" :index="cIndex" :canvas-type="assessmentItem.key + '_'" :img-type="assessmentItem.key" />
                    </div>

                    <span class="uploader_file_name">
                      <el-checkbox :key="cItem.url" :label="cItem" class="checkbox-block">
                        {{ convertFilesName('valuationFilePicList', cItem.url, cItem.name) }}
                      </el-checkbox>
                    </span>
                  </li>
                </el-checkbox-group>
              </ul>
              <!-- 上传文件按钮 -->
              <div
                v-if="checkPermission(assessmentItem.editPermissions, permList) && !isCaseArchive"
                class="uploader_file_uploader"
              >
                <div class="uploader_input_wrp">
                  <i class="el-icon-plus" style="font-size: 28px" />
                  <input
                    type="file"
                    multiple="multiple"
                    class="uploader_input"
                    :accept="uploadFileType"
                    @change="chooseImage(assessmentItem.key, $event)"
                  >
                </div>
              </div>
            </div>
          </el-tab-pane>

          <!-- 操作按钮 -->
          <div class="uploader_button flex">
            <el-button
              v-if="isAssessmentSurveyChildrenSave"
              type="primary"
              icon="el-icon-upload"
              :loading="valuationFileloading"
              :disabled="uploadingNum > 0 || isCaseArchive"
              @click.stop="savePic('valuationFilePicList')"
            >
              保存资料
            </el-button>

            <el-button
              v-if="isAssessmentSurveyChildrenToPMaterial"
              type="primary"
              icon="el-icon-document-copy"
              :loading="transferPicloading"
              :disabled="isCaseArchive"
              @click.stop="transferPic('valuationFilePicList', 'PublicEstimate')"
            >
              转移到公示材料
            </el-button>

            <el-button
              v-if="isAssessmentSurveyChildrenToAMaterial"
              type="primary"
              icon="el-icon-document-copy"
              :loading="transferPicloading"
              :disabled="isCaseArchive"
              @click.stop="transferPic('valuationFilePicList', 'CloseFile')"
            >
              转移到归档资料
            </el-button>
          </div>
        </el-tabs>
      </el-tab-pane>

      <!-- 公示资料 -->
      <el-tab-pane
        v-if="checkPermission('公示资料:查看', permList)"
        label="公示资料"
        name="publicityFileViewer"
      >
        <div class="uploader_content">
          <ul id="publicityFileViewer" class="uploader_files case_detail_uploader_files">
            <li
              v-for="(item, index) in publicityFilePicList"
              :key="'publicityFilePic' + index"
              class="uploader_file_block"
            >
              <!-- 资料上传进度的模块 -->
              <div v-if="item.percentage < 100 && item.percentage >= 0">
                <!-- 删除按钮 -->
                <span
                  v-if="!isCaseArchive"
                  class="uploader_file_del_icon"
                  @click.stop="delLi('publicityFilePicList', index)"
                >
                  <i class="el-icon-close" style="color: white" />
                </span>
                <div class="uploader_file">
                  <el-progress
                    type="circle"
                    :color="colors"
                    :percentage="item.percentage"
                  />
                </div>
              </div>
              <div v-else>
                <!-- 删除按钮 -->
                <span
                  v-if="(checkPermission('公示资料-图片:删除', permList) || item.isDelete) && !isCaseArchive"
                  class="uploader_file_del_icon"
                  @click.stop="delLi('publicityFilePicList', index)"
                >
                  <i class="el-icon-close" style="color: white" />
                </span>

                <v-imageItems :item="item" :index="index" canvas-type="publicity_canvas_" img-type="PublicEstimate" />
              </div>
              <span class="uploader_file_name">{{
                convertFilesName("publicityFilePicList", item.url, item.name)
              }}</span>
            </li>
          </ul>
          <!-- 上传按钮 -->
          <div
            v-if="checkPermission('公示资料:编辑', permList) && !isCaseArchive"
            class="uploader_file_uploader"
          >
            <div class="uploader_input_wrp">
              <i class="el-icon-plus" style="font-size: 28px" />
              <input
                type="file"
                multiple="multiple"
                class="uploader_input"
                :accept="uploadFileType"
                @change="chooseImage('publicityFilePicList', $event)"
              >
            </div>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div v-if="checkPermission('公示资料:编辑', permList)" class="uploader_button">
          <el-button
            type="primary"
            icon="el-icon-upload"
            :loading="publicityFileloading"
            :disabled="uploadingNum > 0 || isCaseArchive"
            @click.stop="savePic('publicityFilePicList')"
          >
            保存资料
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-download"
            :loading="downImgloading"
            :disabled="uploadingNum > 0 || isCaseArchive"
            @click.stop="onDownload('公示资料', 'publicityFilePicList')"
          >
            一键下载
          </el-button>
        </div>
      </el-tab-pane>

      <!-- 归档资料 -->
      <el-tab-pane
        v-if="checkPermission('归档资料:查看', permList)"
        label="归档资料"
        name="closeFileViewer"
      >
        <div class="uploader_content">
          <ul id="closeFileViewer" class="uploader_files case_detail_uploader_files">
            <li
              v-for="(item, index) in closeFilePicList"
              :key="'closeFilePic' + index"
              class="uploader_file_block"
            >
              <!-- 资料上传进度的模块 -->
              <div v-if="item.percentage < 100 && item.percentage >= 0">
                <!-- 删除按钮 -->
                <span
                  v-if="!isCaseArchive"
                  class="uploader_file_del_icon"
                  @click.stop="delLi('closeFilePicList', index)"
                >
                  <i class="el-icon-close" style="color: white" />
                </span>
                <div class="uploader_file">
                  <el-progress
                    type="circle"
                    :color="colors"
                    :percentage="item.percentage"
                  />
                </div>
              </div>
              <div v-else>
                <!-- 删除按钮 -->
                <span
                  v-if="(checkPermission('归档材料-图片:删除', permList) || item.isDelete) && !isCaseArchive"
                  class="uploader_file_del_icon"
                  @click.stop="delLi('closeFilePicList', index)"
                >
                  <i class="el-icon-close" style="color: white" />
                </span>

                <v-imageItems :item="item" :index="index" canvas-type="close_canvas_" img-type="CloseFile" />
              </div>
              <span class="uploader_file_name">{{ convertFilesName("closeFilePicList", item.url, item.name) }}</span>
            </li>
          </ul>
          <div
            v-if="checkPermission('归档资料:编辑', permList) && !isCaseArchive"
            class="uploader_file_uploader"
          >
            <div class="uploader_input_wrp">
              <i class="el-icon-plus" style="font-size: 28px" />
              <input
                type="file"
                multiple="multiple"
                class="uploader_input"
                :accept="uploadFileType"
                @change="chooseImage('closeFilePicList', $event)"
              >
            </div>
          </div>
        </div>

        <div v-if="checkPermission('归档资料:编辑', permList)" class="uploader_button">
          <el-button
            type="primary"
            icon="el-icon-upload"
            :loading="closeFileloading"
            :disabled="uploadingNum > 0 || isCaseArchive"
            class="btn-block"
            @click.stop="savePic('closeFilePicList')"
          >
            保存资料
          </el-button>
        </div>
      </el-tab-pane>

      <!-- 补充资料 -->
      <el-tab-pane
        v-if="checkPermission('补充资料:查看', permList)"
        label="补充资料"
        name="allPhotoViewer"
      >
        <div class="uploader_content">
          <ul id="allPhotoViewer" class="uploader_files case_detail_uploader_files">
            <!-- 日常照 -->
            <li
              v-for="(item, index) in dailyPhotoPicList"
              :key="'dailyPhotoPic' + index"
              class="uploader_file_block"
            >
              <div>
                <!-- 删除按钮 -->
                <span
                  v-if="checkPermission('补充材料-图片:删除', permList) && !isCaseArchive"
                  class="uploader_file_del_icon"
                  @click.stop="delLi('dailyPhotoPicList', index)"
                >
                  <i class="el-icon-close" style="color: white" />
                </span>

                <v-imageItems :item="item" :index="index" canvas-type="dailyPhoto_canvas_" img-type="AddMaterial" />
              </div>
              <span class="uploader_file_name">{{
                convertFilesName("dailyPhotoPicList", item.url, item.name)
              }}</span>
            </li>
            <!-- 计划照 -->
            <li
              v-for="(item, index) in plainPhotoPicList"
              :key="'plainPhotoPic' + index"
              class="uploader_file_block"
            >
              <div>
                <!-- 删除按钮 -->
                <span
                  v-if="checkPermission('补充材料-图片:删除', permList) && !isCaseArchive"
                  class="uploader_file_del_icon"
                  @click.stop="delLi('plainPhotoPicList', index)"
                >
                  <i class="el-icon-close" style="color: white" />
                </span>

                <v-imageItems :item="item" :index="index" canvas-type="plainPhoto_canvas_" img-type="AddMaterial" />
              </div>
              <span class="uploader_file_name">{{
                convertFilesName("plainPhotoPicList", item.url, item.name)
              }}</span>
            </li>
            <!-- 短信照 -->
            <li
              v-for="(item, index) in sMSPhotoPicList"
              :key="'SMSPhotoPic' + index"
              class="uploader_file_block"
            >
              <div>
                <!-- 删除按钮 -->
                <span
                  v-if="checkPermission('补充材料-图片:删除', permList) && !isCaseArchive"
                  class="uploader_file_del_icon"
                  @click.stop="delLi('sMSPhotoPicList', index)"
                >
                  <i class="el-icon-close" style="color: white" />
                </span>

                <v-imageItems :item="item" :index="index" canvas-type="SMSPhoto_canvas_" img-type="AddMaterial" />
              </div>
              <span class="uploader_file_name">{{
                convertFilesName("sMSPhotoPicList", item.url, item.name)
              }}</span>
            </li>
            <!-- 收据照 -->
            <li
              v-for="(item, index) in receiptPhotoPicList"
              :key="'receiptPhotoPic' + index"
              class="uploader_file_block"
            >
              <div>
                <!-- 删除按钮 -->
                <span
                  v-if="checkPermission('补充材料-图片:删除', permList) && !isCaseArchive"
                  class="uploader_file_del_icon"
                  @click.stop="delLi('receiptPhotoPicList', index)"
                >
                  <i class="el-icon-close" style="color: white" />
                </span>

                <v-imageItems :item="item" :index="index" canvas-type="receiptPhoto_canvas_" img-type="AddMaterial" />
              </div>
              <span class="uploader_file_name">{{
                convertFilesName("receiptPhotoPicList", item.url, item.name)
              }}</span>
            </li>
            <!-- 感谢照 -->
            <li
              v-for="(item, index) in thankPhotoPicList"
              :key="'thankPhotoPic' + index"
              class="uploader_file_block"
            >
              <div>
                <!-- 删除按钮 -->
                <span
                  v-if="checkPermission('补充材料-图片:删除', permList) && !isCaseArchive"
                  class="uploader_file_del_icon"
                  @click.stop="delLi('thankPhotoPicList', index)"
                >
                  <i class="el-icon-close" style="color: white" />
                </span>

                <v-imageItems :item="item" :index="index" canvas-type="thankPhoto_canvas_" img-type="AddMaterial" />
              </div>
              <span class="uploader_file_name">{{
                convertFilesName("thankPhotoPicList", item.url, item.name)
              }}</span>
            </li>
          </ul>
        </div>

        <div v-if="checkPermission('补充资料:编辑', permList)" class="uploader_button">
          <el-button
            type="primary"
            icon="el-icon-upload"
            :loading="allPhotoloading"
            :disabled="uploadingNum > 0 || isCaseArchive"
            class="btn-block"
            @click.stop="savePic('allPhotoPicList')"
          >
            保存资料
          </el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapState } from 'vuex'
import NP from 'number-precision' // 使用js精确地执行加法、减法、乘法和除法运算
import ImageItems from '../imageItem' // 资料显示子组件
import JSZip from "jszip";
import { saveAs } from "file-saver";

export default {
  name: 'ImageInfo',

  components: {
    'v-imageItems': ImageItems
  },

  props: {

    // 案件编号
    caseCode: {
      type: String,
      default: () => {
        return ''
      }
    },

    // 案件资料
    caseFilePicList: {
      type: Array,
      default: () => {
        return []
      }
    },

    // 公示资料
    publicityFilePicList: {
      type: Array,
      default: () => {
        return []
      }
    },

    // 公估调查资料列表(2021年7月27日新增)
    assessmentSurveyList: {
      type: Array,
      default: () => []
    },

    // 归档资料
    closeFilePicList: {
      type: Array,
      default: () => {
        return []
      }
    },

    // 上传扫描件资料
    scanFilePicList: {
      type: Array,
      default: () => {
        return []
      }
    },

    // 日常照
    dailyPhotoPicList: {
      type: Array,
      default: () => {
        return []
      }
    },

    // 计划照
    plainPhotoPicList: {
      type: Array,
      default: () => {
        return []
      }
    },

    // 短信照
    sMSPhotoPicList: {
      type: Array,
      default: () => {
        return []
      }
    },

    // 收据照
    receiptPhotoPicList: {
      type: Array,
      default: () => {
        return []
      }
    },

    // 感谢照
    thankPhotoPicList: {
      type: Array,
      default: () => {
        return []
      }
    },

    // 预计到顶部的距离
    tabScrollTop: {
      type: Number,
      default: () => {
        return 0
      }
    }
  },

  data() {
    return {
      activeName: 'caseFileViewer', // 最外层标签页组件的绑定值，选中选项卡的 name
      delList: {
        AddMaterialDailyPhoto: [], // 补充资料-日常照
        AddMaterialPlainPhoto: [], // 补充资料-计划照
        AddMaterialSMSPhoto: [], // 补充资料-短信照
        AddMaterialReceiptPhoto: [], // 补充资料-收据照
        AddMaterialThankPhoto: [], // 补充资料-感谢照
        PaperScan: [], // 纸质扫描件
        PublicEstimate: [], // 待公示资料
        CloseFile: [], // 归档资料
        Valuation: [], // 公估结果-既往材料及调查函
        ValuationIdentityCheck: [], // 公估结果-身份核查及面访材料(2021年7月27日新增)
        ValuationInsurance: [], // 公估结果-社保及商保材料(2021年7月27日新增)
        ValuationHospital: [], // 公估结果-医院排查材料(2021年7月27日新增)
        ValuationExam: [], // 公估结果-体检材料(2021年7月27日新增)
        ValuationOtherSurvey: [] // 公估结果-其他材料以及调查报告(2021年7月27日新增)
      },
      dataChangeNum: 0, // 记录数据变化情况（记录保存操作）
      dataDelChangeNum: 0, // 记录数据变化情况（记录删除操作）
      tagTechnicalSelection: [],
      // 保存资料按钮的加载状态
      scanFileloading: false,
      transferPicloading: false, // 转移到公示材料、转移到归档资料
      valuationFileloading: false,
      publicityFileloading: false,
      downImgloading: false,
      closeFileloading: false,
      allPhotoloading: false,
      uploadingNum: 0, // 判断正在上传的图片数量

      // 公估调查资料-标签页的绑定值
      assessmentActiveName: 'assessment_identity_verification',

      // 视频默认格式
      video: {
        videoImg:
          'http://ehuzhu-1251082375.cos.ap-guangzhou.myqcloud.com/cms/7c6c9485913cc8c91ae8.png',
        playStatus: '',
        muteStatus: '',
        isMute: true,
        isPlay: false,
        width: '125', // 设置视频播放器的显示宽度（以像素为单位）
        height: '125', // 设置视频播放器的显示高度（以像素为单位）
        preload: 'auto', //  建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        controls: true // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      },
      // 视频/音频文件格式
      imageTypes: [
        'mp4',
        'MP4',
        'wma',
        'mpeg',
        'avi',
        'mov',
        'flv',
        'f4v',
        'rmvb',
        'mp3'
      ],
      appPath: this.homePath() || '',

      // 上传文件所需参数
      bucketName: '',
      region: '',
      secretId: '',
      secretKey: '',

      // 进度条背景色（会覆盖 status 状态颜色）
      colors: [
        { color: '#f56c6c', percentage: 25 },
        { color: '#e6a23c', percentage: 50 },
        { color: '#5cb87a', percentage: 75 },
        { color: '#1989fa', percentage: 100 }
      ],

      // 规定上传的文件类型
      uploadFileType: '.aac,.aif,.flac,.iff,.m4a,.m4b,.mid,.midi,.mp3,.mpa,.mpc,.oga,.ogg,.opus,.ra,.ram,.snd,.wav,.wma,.avi,.divx,.flv,.m4v,.mkv,.mov,.mp4,.mpeg,.mpg,.ogm,.ogv,.ogx,.rm,.rmvb,.smil,.webm,.wmv,.xvid,.jpe,.jpg,.jpeg,.gif,.png,.bmp,.ico,.svg,.svgz,.tif,.tiff,.ai,.drw,.pct,.psp,.xcf,.psd,.raw,.webp,.doc,.docx,.pdf'
    }
  },

  computed: {
    ...mapState({
      caseInfo: (state) => state.caseDetail.caseInfo,
      permList: (state) => state.permission.permList
    }),

    /**
     * 判断公估调查资料的子项中是否有“保存资料”的权限
     */
    isAssessmentSurveyChildrenSave() {
      const { permList, assessmentActiveName, assessmentSurveyList } = this
      let permissions = ''

      assessmentSurveyList && assessmentSurveyList.forEach(item => {
        if (assessmentActiveName === item.name) permissions = item.editPermissions
      })

      return this.checkPermission(permissions, permList)
    },

    /**
     * 判断公估调查资料的子项中是否有“转移到公示材料”的权限
     */
    isAssessmentSurveyChildrenToPMaterial() {
      const { permList, assessmentActiveName, assessmentSurveyList } = this
      let permissions = ''

      assessmentSurveyList && assessmentSurveyList.forEach(item => {
        if (assessmentActiveName === item.name) permissions = item.toPMaterialPermissions
      })

      return this.checkPermission(permissions, permList)
    },

    /**
     * 判断公估调查资料的子项中是否有“转移到归档材料”的权限
     */
    isAssessmentSurveyChildrenToAMaterial() {
      const { permList, assessmentActiveName, assessmentSurveyList } = this
      let permissions = ''

      assessmentSurveyList && assessmentSurveyList.forEach(item => {
        if (assessmentActiveName === item.name) permissions = item.toAMaterialPermissions
      })

      return this.checkPermission(permissions, permList)
    },

    // 判断当前案件是否为“归档”流程
    isCaseArchive() {
      return this.caseInfo.flowCode >= 103500;
    },
  },

  created() {
    this.getCosInfo()
  },

  methods: {

    /**
     * 扫描文件转移到公示材料
     * @param {string} type
     * @param {string} target
     */
    async transferPic(type, target) {
      const _this = this
      const { tagTechnicalSelection, caseCode } = _this
      if (tagTechnicalSelection && tagTechnicalSelection.length === 0) {
        _this.$alert('请选择数据', '提示')
        return
      }
      const attachmentList = {}
      if (type === 'scanFilePicList') {
        attachmentList['PaperScan'] = tagTechnicalSelection
      } else if (type === 'valuationFilePicList') { // 公估调查资料
        const { assessmentSurveyList } = _this
        // 遍历公估调查的图片列表，查询出和选中图片name相等的图片，并按key分类组合数据
        assessmentSurveyList && assessmentSurveyList.forEach(item => {
          item && item.children && item.children.forEach(cItem => {
            tagTechnicalSelection && tagTechnicalSelection.forEach(tItem => {
              if (cItem.name === tItem.name) {
                if (!attachmentList[item.key]) attachmentList[item.key] = []
                attachmentList[item.key].push(tItem)
              }
            })
          })
        })
      }

      _this.transferPicloading = true

      const attm = {
        caseCode,
        attachmentType: target,
        attachmentList,
        delList: {}
      }
      try {
        const { data: result } = await _this.axios.put(
          `/casesCommon/transferPic`,
          attm
        )
        if (result && result.status === '000000') {
          _this.tagTechnicalSelection = []
          _this.$alert('保存成功', '提示')
          _this.$emit('getImageByCaseCode') // 重新加载照片资料
        } else {
          _this.$alert(result && result.message, '提示')
        }

        _this.transferPicloading = false
      } catch (error) {
        _this.transferPicloading = false
        console.log('扫描文件转移到公示材料-请求失败', error)
      }
    },

    /**
     * 获取cos信息
     */
    async getCosInfo() {
      const _this = this
      const { appPath } = _this

      try {
        const { data: resData } = await _this.axios(`${appPath}/case-info/getCosInfo`)
        if (resData && resData.status === '000000') {
          _this.bucketName = resData.data.bucketName
          _this.region = resData.data.region
          _this.secretId = resData.data.secretId
          _this.secretKey = resData.data.secretKey
        } else {
          console.warn('获取cos信息-请求失败', resData && resData.message)
        }
      } catch (error) {
        console.log('获取cos信息-请求失败', error)
      }
    },

    /**
     * tab 被选中时触发
     * @param {any} tab
     */
    handleClick(tab) {
      this.tagTechnicalSelection = []

      // 修改滚动条位置
      if (tab.name === 'caseFileViewer') { // 照片资料
        this.setCotainerScrollTop(1)
      } else if (tab.name === 'publicityFileViewer') { // 公示资料
        this.setCotainerScrollTop(1.5)
      } else if (tab.name === 'valuationFileViewer') { // 公估调查资料
        this.setCotainerScrollTop(2)
      } else if (tab.name === 'closeFileViewer') { // 归档资料
        this.setCotainerScrollTop(2.5)
      } else if (tab.name === 'scanFileViewer') { // 扫描件资料
        this.setCotainerScrollTop(3)
      } else if (tab.name === 'allPhotoViewer') { // 补充资料
        this.setCotainerScrollTop(3.5)
      }
    },

    /**
     * 公估调查资料-tab 被选中时触发
     * @param {any} tab
     */
    onChangeAssessmentTag(tab) {
      const _this = this
      const { name } = tab

      if (name === 'assessment_identity_verification') {
        _this.setCotainerScrollTop(4)
      } else if (name === 'assessment_social_security') {
        _this.setCotainerScrollTop(4.5)
      } else if (name === 'assessment_hospital_screening') {
        _this.setCotainerScrollTop(5)
      } else if (name === 'assessment_medical') {
        _this.setCotainerScrollTop(6)
      } else if (name === 'assessment_other_materials') {
        _this.setCotainerScrollTop(7)
      } else if (name === 'always_material') {
        _this.setCotainerScrollTop(8)
      }
    },

    /**
     * 设置滚动条到顶部的距离
     * 注意：为了能让图片默认显示成功，而修改滚动条的距离
     * @param {number} nums 数值
     */
    setCotainerScrollTop(nums = 0) {
      const _this = this

      setTimeout(() => {
        const { tabScrollTop } = _this
        const elMain = $('.el-main')

        let sTop = tabScrollTop + 40
        sTop += nums

        elMain.animate({ scrollTop: sTop }, 250)
      }, 100)
    },

    /**
     * 删除资料
     * @param {string} 类型
     * @param {number} 下标值
     */
    delLi(type, index) {
      if (this.uploadingNum > 0) {
        this.uploadingNum--
      }

      // 补充资料-日常照
      if (type === 'dailyPhotoPicList') {
        this.delList['AddMaterialDailyPhoto'].push(this[type][index])
        this[type].splice(index, 1)
      }

      // 补充资料-计划照
      if (type === 'plainPhotoPicList') {
        this.delList['AddMaterialPlainPhoto'].push(this[type][index])
        this[type].splice(index, 1)
      }

      // 补充资料-短信照
      if (type === 'sMSPhotoPicList') {
        this.delList['AddMaterialSMSPhoto'].push(this[type][index])
        this[type].splice(index, 1)
      }

      // 补充资料-收据照
      if (type === 'receiptPhotoPicList') {
        this.delList['AddMaterialReceiptPhoto'].push(this[type][index])
        this[type].splice(index, 1)
      }

      // 补充资料-感谢照
      if (type === 'thankPhotoPicList') {
        this.delList['AddMaterialThankPhoto'].push(this[type][index])
        this[type].splice(index, 1)
      } else if (type === 'scanFilePicList') { // 扫描件资料
        this.delList['PaperScan'].push(this[type][index])
        this[type].splice(index, 1)
      } else if (type === 'publicityFilePicList') { // 公示资料
        this.delList['PublicEstimate'].push(this[type][index])
        this[type].splice(index, 1)
      } else if (type === 'closeFilePicList') { // 归档资料
        this.delList['CloseFile'].push(this[type][index])
        this[type].splice(index, 1)
      }

      if ( // 公估调查资料
        type === 'ValuationIdentityCheck' ||
        type === 'ValuationInsurance' ||
        type === 'ValuationHospital' ||
        type === 'ValuationExam' ||
        type === 'ValuationOtherSurvey' ||
        type === 'Valuation'
      ) {
        const { assessmentSurveyList } = this
        assessmentSurveyList && assessmentSurveyList.forEach((item, pIndex) => {
          if (item.key === type) {
            this.delList[type].push(item.children[index])
            assessmentSurveyList[pIndex].children.splice(index, 1)
          }
        })
        this.assessmentSurveyList = assessmentSurveyList
      }
      this.dataChangeNum++
    },

    /**
     * 点击保存按钮资料事件
     * @param {string} 保存的资料类型
     */
    savePic(type) {
      if (this.dataChangeNum === 0 && this.dataDelChangeNum === 0) {
        this.$alert('图片无变动不需要保存！', '提示')
        return
      }
      const attachmentList = {}
      if (type === 'scanFilePicList') {
        this.scanFileloading = true
        attachmentList['PaperScan'] = this.scanFilePicList
      } else if (type === 'valuationFilePicList') {
        this.valuationFileloading = true
        // 以下内容2021年7月27日新增
        const { assessmentSurveyList } = this

        assessmentSurveyList && assessmentSurveyList.forEach(item => {
          attachmentList[item.key] = item.children
        })
      } else if (type === 'publicityFilePicList') {
        this.publicityFileloading = true
        attachmentList['PublicEstimate'] = this.publicityFilePicList
      } else if (type === 'closeFilePicList') {
        this.closeFileloading = true
        attachmentList['CloseFile'] = this.closeFilePicList
      } else if (type === 'allPhotoPicList') {
        this.allPhotoloading = true
        attachmentList['AddMaterialDailyPhoto'] = this.dailyPhotoPicList
        attachmentList['AddMaterialPlainPhoto'] = this.plainPhotoPicList
        attachmentList['AddMaterialSMSPhoto'] = this.sMSPhotoPicList
        attachmentList['AddMaterialReceiptPhoto'] = this.receiptPhotoPicList
        attachmentList['AddMaterialThankPhoto'] = this.thankPhotoPicList
      }
      this.saveFile(attachmentList)
    },

    /**
     * 图片资料保存
     * @param {any} 附件列表
     */
    async saveFile(attachmentList) {
      const _this = this
      const { caseCode, appPath, delList } = _this
      const newdelList = {}

      if (Object.keys(delList).length > 0) {
        const {
          AddMaterialDailyPhoto,
          AddMaterialPlainPhoto,
          AddMaterialSMSPhoto,
          AddMaterialReceiptPhoto,
          AddMaterialThankPhoto,
          PaperScan, // 纸质扫描件
          PublicEstimate, // 待公示资料
          CloseFile, // 归档资料
          Valuation, // 既往材料及调查函
          ValuationIdentityCheck, // 公估结果-身份核查及面访材料(2021年7月27日新增)
          ValuationInsurance, // 公估结果-社保及商保材料(2021年7月27日新增)
          ValuationHospital, // 公估结果-医院排查材料(2021年7月27日新增)
          ValuationExam, // 公估结果-体检材料(2021年7月27日新增)
          ValuationOtherSurvey // 公估结果-其他材料以及调查报告(2021年7月27日新增)
        } = _this.delList

        if (AddMaterialDailyPhoto && AddMaterialDailyPhoto.length > 0) {
          newdelList['AddMaterialDailyPhoto'] = AddMaterialDailyPhoto
        }
        if (AddMaterialPlainPhoto && AddMaterialPlainPhoto.length > 0) {
          newdelList['AddMaterialPlainPhoto'] = AddMaterialPlainPhoto
        }
        if (AddMaterialSMSPhoto && AddMaterialSMSPhoto.length > 0) {
          newdelList['AddMaterialSMSPhoto'] = AddMaterialSMSPhoto
        }
        if (AddMaterialReceiptPhoto && AddMaterialReceiptPhoto.length > 0) {
          newdelList['AddMaterialReceiptPhoto'] = AddMaterialReceiptPhoto
        }
        if (AddMaterialThankPhoto && AddMaterialThankPhoto.length > 0) {
          newdelList['AddMaterialThankPhoto'] = AddMaterialThankPhoto
        }

        if (PaperScan && PaperScan.length > 0) {
          newdelList['PaperScan'] = PaperScan
        }
        if (PublicEstimate && PublicEstimate.length > 0) {
          newdelList['PublicEstimate'] = PublicEstimate
        }
        if (CloseFile && CloseFile.length > 0) {
          newdelList['CloseFile'] = CloseFile
        }

        // 公估调查资料-既往材料及调查函
        if (Valuation && Valuation.length > 0) {
          newdelList['Valuation'] = Valuation
        }
        // 以下公估调查资料内容(2021年7月27日新增)
        // 身份核查及面访材料
        if (ValuationIdentityCheck && ValuationIdentityCheck.length) {
          newdelList['ValuationIdentityCheck'] = ValuationIdentityCheck
        }
        // 社保及商保材料
        if (ValuationInsurance && ValuationInsurance.length) {
          newdelList['ValuationInsurance'] = ValuationInsurance
        }
        // 医院排查材料
        if (ValuationHospital && ValuationHospital.length) {
          newdelList['ValuationHospital'] = ValuationHospital
        }
        // 体检材料
        if (ValuationExam && ValuationExam.length) {
          newdelList['ValuationExam'] = ValuationExam
        }
        // 其他材料以及调查报告
        if (ValuationOtherSurvey && ValuationOtherSurvey.length) {
          newdelList['ValuationOtherSurvey'] = ValuationOtherSurvey
        }
      }

      const attm = {
        caseCode,
        attachmentList,
        delList: newdelList
      }
      try {
        const { data: result } = await _this.axios.put(
          appPath + '/casesCommon/uploadImage',
          attm
        )

        if (result && result.status === '000000') {
          _this.$alert('保存成功', '提示')
          _this.delList = {
            AddMaterialDailyPhoto: [], // 补充资料-日常照
            AddMaterialPlainPhoto: [], // 补充资料-计划照
            AddMaterialSMSPhoto: [], // 补充资料-短信照
            AddMaterialReceiptPhoto: [], // 补充资料-收据照
            AddMaterialThankPhoto: [], // 补充资料-感谢照
            PaperScan: [], // 纸质扫描件
            PublicEstimate: [], // 待公示资料
            CloseFile: [], // 归档资料
            Valuation: [], // 公估结果-既往材料及调查函
            ValuationIdentityCheck: [], // 公估结果-身份核查及面访材料(2021年7月27日新增)
            ValuationInsurance: [], // 公估结果-社保及商保材料(2021年7月27日新增)
            ValuationHospital: [], // 公估结果-医院排查材料(2021年7月27日新增)
            ValuationExam: [], // 公估结果-体检材料(2021年7月27日新增)
            ValuationOtherSurvey: [] // 公估结果-其他材料以及调查报告(2021年7月27日新增)
          }
          _this.dataChangeNum = 0
        } else {
          _this.$alert(result && result.message, '提示')
        }

        _this.scanFileloading = false
        _this.valuationFileloading = false
        _this.publicityFileloading = false
        _this.closeFileloading = false
        _this.allPhotoloading = false

        _this.$emit('getImageByCaseCode') // 重新加载照片资料
      } catch (error) {
        console.log('保存资料-请求失败', error)
      }
    },

    // 一键下载所有文件
    onDownload(name, type) {
      const urlList = this[type].map((item) => {
        return item.url.replace(/^http:/i, 'https:')
      });
      const { caseId } = this.caseInfo;
      this.downloadFiles(`${caseId}-${name}`, urlList);
    },
    // 下载实现方法
    async downloadFiles(name, list) {
      if (!list.length) return this.$alert("不存在下载的文件");
      const zip = new JSZip();
      this.downImgloading = true;
      try {
        // 并行下载所有文件
        await Promise.all(
          list.map(async (url) => {
            const response = await fetch(url);
            if (!response.ok) return this.$alert("下载失败");
            const blob = await response.blob();
            const filename = this.convertFilesName("", "", url); // 提取文件名
            zip.file(filename, blob);
          })
        );

        // 生成ZIP并下载
        const content = await zip.generateAsync({ type: "blob" });
        saveAs(content, `${name}.zip`);
        this.$alert("下载成功");
      } catch (error) {
        this.$alert("下载失败");
      }
      this.downImgloading = false;
    },

    /**
     * 转换文件的名称
     */
    convertFilesName(type, url, obj) {
      if (type === 'valuationFilePicList') {
        const keyArray = url.split('.')
        const keySuffix = keyArray[keyArray.length - 1]
        if (keySuffix.toLowerCase() === 'doc') {
          return obj.replace(/-(.*?)_/i, '_')
        }
      }
      return obj.replace(/(.*?)_/i, '').replace(/(.*?)_/i, '')
    },

    /**
     * 选择图像
     */
    chooseImage(type, event) {
      const _this = this
      const { files } = event.target
      const signTxt = [] // 记录不符合上传文件的文件格式
      let sign = 0 // 标记选择的文件中，有多少个符合上传文件格式的
      for (let i = 0; i < files.length; i++) {
        const filesNameArr = files[i].name.split('.')
        const name = '.' + filesNameArr[filesNameArr.length - 1] // 文件后缀名
        if (name && _this._isUploadFileType(name)) {
          sign++
        } else { // 记录不符合上传文件的文件格式
          if (signTxt.indexOf(name) === -1) signTxt.push(name)
        }
      }

      // 如果全部选择的文件都符合上传格式要求，则进入“uploadImage”方法，否则返回页面提示
      if (sign && sign === files.length) {
        _this.uploadImage(type, files)
        event.target.value = ''
      } else {
        if (signTxt.length) {
          _this.$alert(`很抱歉，当前文件格式（${signTxt}）不可以上传`, '提示')
        }
      }
    },

    /**
     * 上传图片前的参数准备
     */
    uploadImage(type, files) {
      const _this = this
      for (let i = 0; i < files.length; i++) {
        _this.uploadingNum++
        const name = files[i].name
        const key = new Date().getTime() + '_' + name
        const picObj = { url: '', name: key, percentage: 0 }
        let n = 0
        let signIndex = null

        if (
          type === 'ValuationIdentityCheck' ||
          type === 'ValuationInsurance' ||
          type === 'ValuationHospital' ||
          type === 'ValuationExam' ||
          type === 'Valuation' ||
          type === 'ValuationOtherSurvey'
        ) {
          const { assessmentSurveyList } = _this

          assessmentSurveyList && assessmentSurveyList.forEach((item, index) => {
            if (item.key === type) {
              assessmentSurveyList[index].children.push(picObj)
              signIndex = index
            }
          })
          _this.assessmentSurveyList = assessmentSurveyList
          n = _this.assessmentSurveyList[signIndex].length - 1
        } else {
          _this[type].push(picObj)
          n = _this[type].length - 1
        }

        _this.upload_result(type, key, files[i], n, signIndex)
      }
    },

    /**
     * 上传资料文件
     */
    async upload_result(type, key, fileObj, n, signIndex = null) {
      const _this = this

      const COS = require('cos-js-sdk-v5')
      let cos = {}
      let Bucket = ''
      let Region = ''
      cos = new COS({
        SecretId: _this.secretId, // 密钥id
        SecretKey: _this.secretKey // 密钥的key
      })
      Bucket = _this.bucketName
      Region = _this.region

      // 上传对象
      cos.putObject(
        {
          Bucket: Bucket, // 桶名-APPID  必须
          Region: Region, // 区域 必须
          Key: key, // 文件名必须
          StorageClass: 'Standard_IA',
          Body: fileObj, // 上传文件对象
          // 进度的回调函数，进度回调响应对象
          onProgress: function(progressData) {
            let name = ''
            const { assessmentSurveyList } = _this
            if (signIndex !== null) {
              name = assessmentSurveyList[signIndex] && assessmentSurveyList[signIndex].children[n] && assessmentSurveyList[signIndex].children[n].name // 文件名
            } else {
              name = _this[type] && _this[type][n] && _this[type][n].name // 文件名
            }

            // 判断当前文件名是否对应数组中下标值的文件名一致
            if (name && name === key) {
              if (signIndex !== null) {
                _this.assessmentSurveyList[signIndex].children[n].percentage = NP.times(progressData.percent, 100)
              } else {
                _this[type][n].percentage = NP.times(progressData.percent, 100)
              }
            } else { // 如果不是，则重新遍历数组，寻找对应的下标值
              const newIndex = _this._getTypeArrIndex(type, key, signIndex)
              if (newIndex !== null) {
                if (signIndex !== null) {
                  _this.assessmentSurveyList[signIndex].children[newIndex].percentage = NP.times(progressData.percent, 100)
                } else {
                  _this[type][newIndex].percentage = NP.times(progressData.percent, 100)
                }
              }
            }
          }
        },
        // 回调函数
        function(err) {
          if (err) {
            _this.uploadingNum = 0
            console.info(err)
            console.info({ success: false, msg: '文件上传失败!' })
            _this.delLi(type, n) // 上传失败，删除当前图片
            return false
          }

          const newIndex = _this._getTypeArrIndex(type, key, signIndex)
          if (newIndex !== null) {
            const picUrl = 'http://' + Bucket + '.cos.ap-guangzhou.myqcloud.com/' + key
            const picObj = { url: picUrl, name: key, isDelete: true }
            if (signIndex !== null) {
              _this.assessmentSurveyList[signIndex].children[newIndex] = picObj
            } else {
              _this[type][newIndex] = picObj
            }
            _this.uploadingNum--
            _this.dataChangeNum++
          }
        }
      )
    },

    /**
     * 返回对应文件数组，文件名相同的数据下标值
     * @param {string} type 上传文件的类型
     * @param {string} key  上传文件的名称
     */
    _getTypeArrIndex(type, key, signIndex = null) {
      let typeArrData = []

      if (signIndex !== null) {
        const { assessmentSurveyList } = this
        typeArrData = assessmentSurveyList[signIndex].children
      } else {
        typeArrData = this[type] // 当前类型的资料数组
      }
      let newIndex = null // 当前资料的下标值

      // 遍历资料数组，根据文件名获取对应的下标志
      typeArrData &&
        typeArrData.forEach((item, index) => {
          if (item.name === key) newIndex = index
        })

      return newIndex
    },

    /**
     * 判断文件后缀名是否符合上传文件的格式要求
     * @param {string} name 文件的后缀名
     */
    _isUploadFileType(name) {
      const { uploadFileType } = this

      name = name.toLowerCase() // 将文件后缀名转小写字母

      if (uploadFileType.indexOf(name) !== -1) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.uploader_button {
  .btn-block {
    width: 100%;
  }
}

/* 查看影像 */
.case_detail_uploader_files {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;

  .checkbox-block {
    width: 128px;
    display: flex;
    align-items: flex-start;

    /deep/ .el-checkbox__label {
      word-break: break-all;
      flex: 1;
      white-space: normal;
      line-height: 18px;
      text-align: left;
      margin-top: -2px;
    }
  }
}

.img-block {
  width: 128px;
  height: 128px;
}
</style>
